// Copyright (c) 2017 Deere & Company

import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import actions from '../../action-list';
import {getMatchingObjects} from '../../../shared/services/key-matcher';
import {updateList} from '../../../shared/services/list-selections';

const defaultClaimTypeKeys = ['ZNRM', 'ZPAR', 'ZPIP', 'ZSPA', 'ZZBT', 'ZZMK', 'ZZNS', 'ZZTK'];

const readClaimTypes = (state, action) =>
    Facets.update(state, {
        claimTypesFacet: {
            $merge: {
                allowedTypes: action.data,
                isInitialLoad: false,
                selectedClaimTypes: getMatchingObjects(defaultClaimTypeKeys, action.data)
            }
        }
    });

const updateDateRangeFacet = (state, action) =>
    Facets.update(state, {
        claimDateRangeFacet: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateDateType = (state, action) =>
    Facets.update(state, {
        dateTypeFacet: {
            key: {$set: action.dateType}
        }
    });

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        claimDateRangeFacet: {
            dateRange: {
                $set: action.claimDateRange
            }
        },
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: action.claimStatus
            }
        },
        claimTypesFacet: {
            selectedClaimTypes: {
                $set: getMatchingObjects(defaultClaimTypeKeys, action.claimTypes)
            }
        },
        dateTypeFacet: {
            key: {$set: getDefaultState().dateTypeFacet.key}
        },
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.dealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealerAccounts
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const toggleClaimTypeFacetItems = (state, action) => {

    const updatedSelectedTypes = state.claimTypesFacet.selectedClaimTypes.length ?
        [] :
        action.allowedTypes;

    return Facets.update(state, {
        claimTypesFacet: {
            selectedClaimTypes: {
                $set: updatedSelectedTypes
            }
        }
    });

};

const toggleClaimStatusFacetItems = (state, action) => {

    const updatedSelectedTypes = state.claimStatusFacet.selectedClaimStatus.length ?
        [] :
        action.allowedStatus;

    return Facets.update(state, {
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: updatedSelectedTypes
            }
        }
    });

};

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateClaimTypeFacetItem = (state, action) =>
    Facets.update(state, {
        claimTypesFacet: {
            selectedClaimTypes: {
                $set: updateList(
                    action.claimType,
                    action.isSelected,
                    'key',
                    state.claimTypesFacet.selectedClaimTypes
                )
            }
        }
    });

const updateClaimStatusFacetItem = (state, action) =>
    Facets.update(state, {
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: updateList(
                    action.claimStatus,
                    action.isSelected,
                    'key',
                    state.claimStatusFacet.selectedClaimStatus
                )
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateClaimStatusItems = (state, action) =>
    Facets.update(state, {
        claimStatusFacet: {
            isInitialLoad: {$set: false},
            selectedClaimStatus: {$set: action.allowedStatus}
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_CLAIM_SEARCH_CLAIM_TYPES_SUCCESS]: readClaimTypes,
        [actions.RESET_CLAIM_SEARCH_FILTERS]: resetAllFacets,
        [actions.TOGGLE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.TOGGLE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEMS]: toggleClaimTypeFacetItems,
        [actions.TOGGLE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS]: toggleClaimStatusFacetItems,
        [actions.UPDATE_CLAIM_DATE_RANGE_FACET]: updateDateRangeFacet,
        [actions.UPDATE_CLAIM_DATE_TYPE]: updateDateType,
        [actions.UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEM]: updateClaimTypeFacetItem,
        [actions.UPDATE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEM]: updateClaimStatusFacetItem,
        [actions.SELECT_ALL_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS]: updateClaimStatusItems,
        [actions.SELECT_ALL_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claim-search/reducers/facets.js